module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de mis permisos")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarSolicitud) ? _c('div', {
    key: "nueva_solicitud",
    staticClass: "box nueva-solicitud"
  }, [_c('nueva-solicitud-permiso', {
    on: {
      "close": function($event) {
        _vm.mostrarSolicitud = false
      },
      "successNew": _vm.recargarListaSolicitudes
    }
  })], 1) : _vm._e(), (_vm.mostrarListaSolicitudes) ? _c('div', {
    key: "lista_solicitud",
    staticClass: "box lista-solicitud"
  }, [_c('lista-solicitud-permiso', {
    ref: "listasolicitudes",
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudes = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarListaMisPermisos) ? _c('div', {
    key: "lista_mis_permisos",
    staticClass: "box lista-solicitud"
  }, [_c('lista-mis-permisos', {
    on: {
      "close": function($event) {
        _vm.mostrarListaMisPermisos = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67b347f2","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Permisos_Mis_Permisos.vue
// module id = 895
// module chunks = 0